var _path, _mask, _g, _mask2, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMypageEstimatebox = function SvgMypageEstimatebox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD167",
    fillRule: "evenodd",
    d: "M3.785 21.75h16.5V2.25h-16.5z",
    clipRule: "evenodd"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mypage-estimatebox_svg__a",
    width: 20,
    height: 7,
    x: 2,
    y: 15,
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M2.25 15.75h19.5v6H2.25z",
    clipRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mypage-estimatebox_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FF540E",
    fillRule: "evenodd",
    d: "M13.474 15.75a1.5 1.5 0 0 1-3 0H2.25v6h19.5v-6z",
    clipRule: "evenodd"
  }))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "mypage-estimatebox_svg__b",
    width: 20,
    height: 20,
    x: 2,
    y: 2,
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M2.25 21.75h19.5V2.25H2.25z",
    clipRule: "evenodd"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#FF540F",
    fillRule: "evenodd",
    clipRule: "evenodd",
    mask: "url(#mypage-estimatebox_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.8 7.3h10.4V6H6.8zM6.8 9.9h10.4V8.6H6.8zM6.8 12.5H12v-1.3H6.8z"
  }))));
};
export default SvgMypageEstimatebox;